import { z } from 'zod';

const cleanHtml = (html: string): string =>
  html
    // Convertir <br> en saltos de línea
    .replace(/<br\s*\/?>/gi, '\n')
    // Convertir <a href="...">Texto</a> en "Texto (URL)"
    .replace(/<a\s+href="([^"]+)"[^>]*>(.*?)<\/a>/gi, '$2 ($1)')
    // Eliminar el resto de las etiquetas HTML
    .replace(/<[^>]+>/g, '')
    // Limpiar espacios innecesarios
    .replace(/\s+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();


export const AlertaApiSchema = z.object({
  estado_alerta: z.string(),
  descripcion: z.string().transform(cleanHtml),
  mail_receptor: z.string(),
  id: z.number(),
  usuario_id: z.number(),
  fecha_creacion_alerta: z.string(),
  encabezado: z.string(),
  json_metadata: z.any().nullable()
});

export const PaginatedAlertasResponseSchema = z.object({
  total: z.number(),
  page: z.number(),
  limit: z.number(),
  data: z.array(AlertaApiSchema),
  extra: z.record(z.any()).nullable().optional()
});

export const ListarAlertasApiResponseSchema = PaginatedAlertasResponseSchema;

export type AlertaApi = z.infer<typeof AlertaApiSchema>;
export type ListarAlertasApiResponse = z.infer<typeof ListarAlertasApiResponseSchema>; 